import { render } from "./GroupUserCreate.vue?vue&type=template&id=4a58bcd9"
import script from "./GroupUserCreate.vue?vue&type=script&lang=js"
export * from "./GroupUserCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__